<template>
<div class="Auth">
  <div class="Auth__logo">
    <icon-svg symbol="logo"/>
  </div>
  <div class="Auth__promos">
   <h1>Check out our Mobile App</h1>
   <p>Health checkup in the palm of your hand</p>
   <div class="Auth__promos__getBTns">
    <div class="btn google">

      <a href="https://play.google.com/store/apps/details?id=com.healthcheckup.app" target="_blank">
        <!-- <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" height="80"> -->
        <img :src="require('@/assets/googleDownload.svg')" alt="Get it on Google Play" height="40">
      </a>
    </div>
    <div class="btn apple">
    <a href="https://apps.apple.com/us/app/health-checkup/id1520000000" target="_blank">
      <!-- <img src="https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2019-10-01&kind=iossoftware&bubble=ios_apps" alt="Download on the App Store" height="80"> -->
      <img :src="require('@/assets/appleDownload.svg')" alt="Download on the App Store" height="40">
    </a>
    </div>
   </div>
   <div class="report-analysis-img">
    <img :src="require('@/assets/img/report-analysis.png')" alt="report-analysis" height="300"> 
   </div>
  </div>
  <div class="Auth__login">
    <User v-if="$store.getters.username"/>
    <Authorizer v-else/>
  </div>

  <button class="Auth__close"
    @click.prevent="$emit('close')"
    aria-label="Close">&times;</button>
</div>
</template>

<script>
import Authorizer from './Authorizer.vue';
import User from './user.vue';
export default {
  name: 'Auth',
  components: {
    User,
    Authorizer
  },
}
</script>

<style lang="scss">
.Auth {
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  grid-auto-rows: 1fr;
  background-color: var(--light);
  backdrop-filter: saturate(150%) blur(12px);
  &__login {
    border-left: 1px solid white;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
  }
  &__promos {
    margin-top: 6rem;
    background: linear-gradient(0deg, rgba(54, 131, 252, 0.05), rgba(54, 131, 252, 0.05)), #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: lightgrey;
    h1{
      color: #0C1E3C;
      font-weight: 500;
      font-size: 34px;
      line-height: 40px;
      margin-bottom: 0;
    }
    p{
      font-weight: 500;
      font-size:20px;
      line-height: 36px;
      margin-top: 0;
      color: #21355C;
    }
    &__getBTns{
      display: flex;
      .google{
        margin-right: 1rem;
      }
    }
    .report-analysis-img{
      margin-top: 2rem;
    }
  }
  &__logo {
    position: absolute;
    left: 0;
    top: 0;
    margin: 2rem 0 0 4rem;
    .icon {
      display: block;
      height: 64px;
      width: 131px;
    }
  }
  &__close {
    position: absolute;
    right: 0;
    top: 0;
    border: 0;
    margin: 2rem;
    background: none;
    font: 48px/36px Verdana;
    padding: 3px 0 9px;
    width: 48px;
    color: var(--accent);
    opacity: .5;
    cursor: pointer;
    &:hover {
      opacity: unset;
    }
  }
}
</style>